import { mapGetters, mapActions } from 'vuex';

const CLASS_IS_LOADING = 'is-loading';

const loaderMixin = {
  data() {
    return {
      isLoading: false,
    };
  },
  computed: {
    ...mapGetters('app', ['newLoaderIsLoading', 'isLayoutMobile', 'isLayoutDesktop']),
  },
  methods: {
    ...mapActions('app', ['incrNewLoaderCounter', 'decrNewLoaderCounter']),
    loaderAddLegacy(el = null, loadingClass = CLASS_IS_LOADING, changeFlag = true) {
      const target = el || this.$el;
      if (target) {
        target.classList.add(loadingClass);
      }
      if (changeFlag) {
        this.isLoading = true;
      }
    },
    loaderRemoveLegacy(el = null, loadingClass = CLASS_IS_LOADING, changeFlag = true) {
      const target = el || this.$el;
      if (target) {
        target.classList.remove(loadingClass);
      }
      if (changeFlag) {
        this.isLoading = false;
      }
    },
    loaderAdd(el = null, loadingClass = CLASS_IS_LOADING, changeFlag = true) {
      if (this.isLayoutMobile) {
        this.incrNewLoaderCounter();
        if (changeFlag) {
          this.isLoading = true;
        }
      } else {
        this.loaderAddLegacy(el, loadingClass, changeFlag);
      }
    },
    loaderRemove(el = null, loadingClass = CLASS_IS_LOADING, changeFlag = true) {
      if (this.isLayoutMobile) {
        this.decrNewLoaderCounter();
        if (changeFlag) {
          this.isLoading = false;
        }
      } else {
        this.loaderRemoveLegacy(el, loadingClass, changeFlag);
      }
    },
  },
};

export default loaderMixin;
